<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">Buzzer Alarm (AT+GTBZA)</span>
        </div>
      </div>
    </p-header>
  
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col lblStyle">
                <form-input fieldName="Output ID">
                </form-input>
            </div>
            <div class="col">
                <div class="ui-inputgroup">
                    <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.outputId" [min]="0" [max]="2"></p-spinner>
                    <span class="ui-inputgroup-addon">0~2</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row align-items-center">        
        <div class="col row dvcFields">
            <form-input fieldName="Alarm 1"></form-input>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="Output status">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-inputSwitch [(ngModel)]="bzaParameters.outputStatus1"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="duration">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.duration1" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">(x100ms)</span>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="toggleTimes">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.toggleTimes1" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">s</span>
                    </div>
                </div>
            </div>

        </div>
        <div class="col row dvcFields">
            <form-input fieldName="Alarm 2"></form-input>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="Output status">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-inputSwitch [(ngModel)]="bzaParameters.outputStatus2"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="duration">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.duration2" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">(x100ms)</span>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="toggleTimes">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.toggleTimes2" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">s</span>
                    </div>
                </div>
            </div>
        </div>                
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <form-input fieldName="Alarm 3"></form-input>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="Output status">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-inputSwitch [(ngModel)]="bzaParameters.outputStatus3"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="duration">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.duration3" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">(x100ms)</span>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="toggleTimes">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.toggleTimes3" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">s</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col row dvcFields">
            <form-input fieldName="Alarm 4"></form-input>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="Output status">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-inputSwitch [(ngModel)]="bzaParameters.outputStatus4"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="duration">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.duration4" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">(x100ms)</span>
                    </div>
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col lblStyle">
                    <form-input fieldName="toggleTimes">
                    </form-input>
                </div>
                <div class="col">
                    <div class="ui-inputgroup">
                        <p-spinner size="5" step="1" [(ngModel)]="bzaParameters.toggleTimes4" [min]="0" [max]="255"></p-spinner>
                        <span class="ui-inputgroup-addon">0~255</span>
                        <span class="ui-inputgroup-addon">s</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
  </p-accordionTab>